export default __webpack_public_path__ + "static/media/avatar_siti1.a8491c9e.mp3";